export default __webpack_public_path__ + "../img/6bf10ce5e4faa321a595257110cd9a55.png";